/**
 * The browser's current position as { lat, lng }, or null when it is unavailable, denied or times out. Check-in must
 * never be blocked on location, so callers treat null as "could not confirm".
 */
export function getPosition({ timeoutMs = 8000 } = {}) {
  return new Promise((resolve) => {
    const geo = typeof navigator !== "undefined" ? navigator.geolocation : undefined;
    if (!geo) {
      resolve(null);
      return;
    }
    try {
      geo.getCurrentPosition(
        (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        () => resolve(null),
        { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 0 },
      );
    } catch {
      resolve(null);
    }
  });
}
